/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Platform, StyleSheet, useWindowDimensions, View } from 'react-native';
import { AppSidebar } from './AppSidebar';
import { WEB_SIDEBAR_BREAKPOINT } from './navigationManifest';
import { ticketColors } from '../../shared/theme/ticketColors';

type Props = {
  children: React.ReactNode;
};

/**
 * En web ancho muestra sidebar por zonas; en mobile/tablet estrecho solo el contenido (tabs inferiores).
 */
export function AdaptiveAppShell({ children }: Props) {
  const { width } = useWindowDimensions();
  const showSidebar = Platform.OS === 'web' && width >= WEB_SIDEBAR_BREAKPOINT;

  if (!showSidebar) {
    return <>{children}</>;
  }

  return (
    <View style={styles.root}>
      <AppSidebar />
      <View style={styles.main}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'stretch',
    minHeight: 0,
    backgroundColor: ticketColors.bg,
    // Web: floor at viewport when parent height is still indefinite during boot.
    ...(Platform.OS === 'web'
      ? { minHeight: '100vh' as unknown as number }
      : null),
  },
  main: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    backgroundColor: ticketColors.bg,
  },
});
